import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';
import AddDataArchiveContainer from './AddDataArchive/AddDataArchiveContainer';
import SentDataToCustomersArchiveContainer from './dataSentToCustomersReport/SentDataToCustomersArchiveContainer';
import DailyReportsList from './DailyReports/DailyReportsList';
import DailyReportDetails from './DailyReports/DailyReportDetails';
import CustomerCrossCheckReport from './customerCrossCheck/CustomerCrossCheckReport';

export const ReportsPagesConfigs = [
  {
    permittedRole: RoutePermittedRole.admin,
    path: '/Reports/DataSave',
    element: <AddDataArchiveContainer />,
  },
  {
    permittedRole: RoutePermittedRole.admin,
    path: '/Reports/DataSent',
    element: <SentDataToCustomersArchiveContainer />,
  },
  {
    permittedRole: RoutePermittedRole.admin,
    path: '/Reports/DailyReports',
    element: <DailyReportsList />,
  },
  {
    permittedRole: RoutePermittedRole.admin,
    path: '/Reports/DailyReports/:reportId',
    element: <DailyReportDetails />,
  },
  {
    permittedRole: RoutePermittedRole.admin,
    path: '/Reports/CustomerCrossCheck',
    element: <CustomerCrossCheckReport />,
  },
];
